import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CoreConfigService } from '@core/services/config.service';
import { HelpService } from '@core/services/help.service';

@Component({
  standalone: false,
  selector: 'app-ad-redirecting-page',
  templateUrl: './ad-redirecting-page.component.html',
  styleUrls: ['./ad-redirecting-page.component.scss']
})
export class AdRedirectingPageComponent implements OnInit {

  constructor(private route: ActivatedRoute,
    private helpService: HelpService,
    private _coreConfigService: CoreConfigService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.configureLayout();
    this.getRouteData();
  }

  getRouteData(): void {
    const data = this.route.snapshot.data["source"]
    if (data === "discount") {
      this.router.navigate(["upgrade"], { queryParams: { xwlk: "p3j4h" }})
    } else {
      this.redirectUserToLogin();
    }
  }

  redirectUserToLogin(): void {
    const id = this.route.snapshot.queryParams.id;
    console.log(id)
    if (id) {
      this.helpService.redirectUserToMainPage(id).subscribe(
        (res) => {
          setTimeout( () => {
            window.location.href = "https://www.zeraki.app"
          }, 1500)
        },
        () => {
          // Recording the ad click is our bookkeeping; send the visitor on regardless.
          window.location.href = "https://www.zeraki.app"
        }
      )
    }
  }

  configureLayout() {
    this._coreConfigService.config = {
        layout: {
            navbar: {
                hidden: true
            },
            footer: {
                hidden: true
            },
            menu: {
                hidden: true
            },
            customizer: false,
            enableLocalStorage: false
        }
    };
}

}
